import PropTypes from 'prop-types';
import React from 'react';

const HeaderLogo = ({ logoFile, organizationName }) => {
  const logo = `/assets/logo/${logoFile}`;
  const logoAlt = `${organizationName}  Logo`;
  return (
    <img alt={logoAlt} src={logo} height={50} />
  );
};

HeaderLogo.propTypes = {
  logoFile: PropTypes.string,
  organizationName: PropTypes.string,
};

export default HeaderLogo;
